<template>
    <div class="relative sales_statistics_panel">
        <!-- <dataTitle>
            <dateSearch @search="onSearchDetail"></dateSearch>
        </dataTitle> -->
        <DatePicker v-model="daterange" :transfer="true" @on-change="handleDateChange" split-panels confirm :editable="false" type="daterange" style="width: 200px" placeholder="自定义日期"></DatePicker>
        <Button type="primary" @click="onSearch" style="margin-left: 20px; margin-top: 0px">搜索</Button>
        <Button type="info" @click="reset" style="margin-left: 20px; margin-top: 0px">重置</Button>
        <dataTitle class="mt_20" slot="title" title="基础数据"></dataTitle>
        <div class="mt_10 relative flex flex_wrap align_center card_panel">
            <div class="data">
                <div class="data-font" style="">验光总收入</div>
                <div class="data-num">0</div>
            </div>
            <div class="data">
                <div class="data-font" style="">验光订单</div>
                <div class="data-num">{{ count }}</div>
            </div>
            <div class="data">
                <div class="data-font" style="">合格率(%)</div>
                <div class="data-num">{{ bhgrate }}</div>
            </div>
            <!-- <div class="data">
                <div class="data-font" style="">访问UN(次)</div>
                <div class="data-num">0</div>
            </div> -->
        </div>
        <div class="mt_20 relative width_100_percent flex flex_wrap align_start space_between detail_panel">
            <!-- <div class="relative detail_item" style="width: 30%">
                <dataTitle slot="title" title="验光合格率"></dataTitle>
                <div class="relative bar_panel">
                    <div class="wrap-item" style="margin-top: 60px; margin-left: 95px">
                        <div style="position: absolute; position: absolute; top: 90px; left: 195px; font-weight: bold">验光合格率:暂无</div>
                        <div id="main" ref="container" style="width: 500px; height: 300px; left: -97px; top: -47px; z-index: 66666"></div>
                    </div>
                </div>
            </div> -->
            <div class="relative detail_item">
                <dataTitle slot="title" title="验光排名多的城市"></dataTitle>
                <div class="wrap1" style="margin-top: 30px">
                    <Table :columns="columns" :data="keyArr"></Table>
                </div>
            </div>
            <div class="relative detail_item">
                <dataTitle slot="title" title="不合格因素"></dataTitle>
                <div class="relative bar_panel">
                    <div class="wrap-item" style="margin-top: 60px; margin-left: 95px">
                        <!-- <div style="position: absolute; top: 90px; left: 195px; font-weight: bold">暂无</div> -->
                        <div id="main3" ref="container" style="position: absolute; width: 500px; height: 300px; left: 120px; top: -47px; z-index: 66666"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt_20 relative width_100_percent flex flex_wrap align_start space_between detail_panel">
            <div class="relative detail_item">
                <dataTitle slot="title" title="年度销售趋势"></dataTitle>
                <div class="wrap2">
                    <div class="relative bar_panel">
                        <div id="main2" ref="container" style="position: absolute; left: 34px; top: 30px; width: 622px; height: 394px"></div>
                    </div>
                </div>
            </div>
            <div class="relative detail_item">
                <dataTitle slot="title" title="年度销售订单"></dataTitle>
                <div class="relative bar_panel">
                    <!-- <bar className="sales_statistics_detail_bar" yName="单位：数量" :chartData="salesDetail" :height="500"></bar> -->
                    <div id="main1" ref="container" style="position: absolute; left: 34px; top: 30px; width: 622px; height: 394px"></div>
                </div>
            </div>
        </div>
        <mySpin :loading="ajaxLoading"></mySpin>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import { reqSalesStat } from '@/lib/request/auth2';
import dataTitle from './comp/dataTitle';
import dateSearch from './comp/dateSearch';
import bar from './comp/echarts/bar';
import itemCard from './comp/itemCard';
import previewImage from '@/components/previewImage';
import { getCityTitles } from '@/lib/city.data';
import { getFastapps, saveFastapps, getOrder, getAgentStatic, getUser, reqReservationList, photometry, abnormal } from '@/lib/request/auth';
import { rest } from 'lodash';

const moDef = {
    totalSalePrice: 'totalSalePrice', //累计销售额
    todaySalePrice: 'todaySalePrice', //今日销售
    saleDetail: 'saleDetail', //销售明细
    goodSaleDetail: 'goodSaleDetail', //单品销售TOP10
};
export default {
    name: 'salesStatistics',
    components: {
        dataTitle,
        dateSearch,
        bar,
        itemCard,
        previewImage,
    },
    data() {
        return {
            daterange: '',
            total: 0,
            keyArr: [],
            columns: [
                {
                    title: '排名',
                    key: 'index',
                },
                {
                    title: '城市',
                    key: 'city',
                },
                {
                    title: '订单数',
                    key: 'num',
                },
            ],
            lcountArr: [],
            detail: {},
            totalSalePrice: 0,
            todaySalePrice: 0,
            salesDetail: [],
            montDataArr: [],
            xsArr: [],
            salesRankList: [],
            marr: [],
            count: '',
            salesRankColumn: [
                { slot: 'rankNo', title: '排名', width: 70 },
                { slot: 'goods', title: '商品信息' },
                { key: 'nums', title: '累计销量', width: 120 },
            ],
            goodsTableShow: false,
            abArr: [],
            countArr: [],
            bhgrate: 0,
            startdate: '',
            enddate: '',
        };
    },
    mounted() {
        this.getDetail();
        const currentYear = new Date().getFullYear();
        const firstDayOfYear = new Date(currentYear, 0, 1);
        const date = new Date(firstDayOfYear);
        this.getData('orderly', null, this.formatDate(date));
        this.getData6('bt', null, this.formatDate(date));
        this.getData6('orderly', null, this.formatDate(date));
        this.getData6('zx', 'month', this.formatDate(date));
        this.getabnormal();
        setTimeout(() => {
            this.$nextTick(() => {
                // this.initTreeData();
                // this.draw();
                this.draw();
                this.drawzx();
                this.drawzx2();
                this.draw3();
            });
        }, 2000);
    },
    watch: {
        //
    },
    methods: {
        handleDateChange(date) {
            this.startdate = date[0];
            this.enddate = date[1];
            // this.getData('bt', null, this.startdate, this.enddate);
            setTimeout(() => {
                this.$nextTick(() => {
                    this.draw();
                });
            }, 1000);
        },
        reset() {
            const currentYear = new Date().getFullYear();
            const firstDayOfYear = new Date(currentYear, 0, 1);
            const date = new Date(firstDayOfYear);
            this.getData('orderly', null, this.formatDate(date));
            this.getData6('bt', null, this.formatDate(date));
            this.getData6('orderly', null, this.formatDate(date));
            this.getData6('zx', 'month', this.formatDate(date));
            this.daterange = undefined;
            setTimeout(() => {
                this.$nextTick(() => {
                    // this.initTreeData();
                    // this.draw();
                    this.draw();
                    this.drawzx();
                    this.drawzx2();
                    this.draw3();
                });
            }, 2000);
        },
        onSearch() {
            this.getData6('bt', null, this.startdate, this.enddate);
            this.getData6('orderly', null, this.startdate, this.enddate);
            this.getData6('zx', 'month', this.startdate, this.enddate);
            this.getData('orderly', null, this.startdate, this.enddate);
            setTimeout(() => {
                this.$nextTick(() => {
                    // this.initTreeData();
                    // this.draw();
                    this.draw();
                    this.drawzx();
                    this.drawzx2();
                    this.draw3();
                });
            }, 2000);
        },
        getabnormal() {
            abnormal().then(res => {
                // this.abArr = res.data.map(() => item.title);
                // this. countArr = res.data.map(()=>item.count);
                this.countArr = res.data.abnormal_items;
                this.bhgrate = res.data.normal_rate;
                this.countArr.forEach(item => {
                    item.value = item.count;
                    item.name = item.title;
                });
                console.log(this.countArr, ' this.countArr');
                this.countArr = this.countArr.filter((item, index) => index < 6);
                setTimeout(() => {
                    this.$nextTick(() => {
                        // this.initTreeData();
                        this.draw3();
                    });
                }, 1000);
            });
        },
        formatDate(date) {
            const year = date.getFullYear();
            // getMonth() 返回的月份是从 0 开始的，因此需要加 1
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        getData6(name, type, startTime, endTime) {
            getOrder({ start: startTime, end: endTime, status: '1,2,3,4', type: type }).then(res => {
                if (name == 'bt') {
                    var lcountArr = [];
                    this.total = res.data[startTime].count;
                    console.log(res.data[startTime].data_good.length, 'res.data[startTime].data_good.length');
                    if (res.data[startTime].data_good.length != 0) {
                        for (var l in res.data[startTime].data_good) {
                            console.log(res.data[startTime].data_good[l].count, 'l.con');
                            var obj = {};
                            obj.name = res.data[startTime].data_good[l].name;
                            obj.count = res.data[startTime].data_good[l].count;
                            lcountArr.push(obj);
                            //遍历对象，k即为key，obj[k]为当前k对应的值
                        }
                        this.lcountArr = [
                            { value: lcountArr[0].count, name: lcountArr[0].name.slice(0, 6) },
                            { value: lcountArr[1].count, name: lcountArr[1].name.slice(0, 6) },
                            { value: lcountArr[2].count, name: lcountArr[2].name.slice(0, 6) },
                            { value: lcountArr[3].count, name: lcountArr[3].name.slice(0, 6) },
                            { value: lcountArr[4].count, name: lcountArr[4].name.slice(0, 6) },
                        ];
                    } else {
                        this.lcountArr = [];
                    }
                    setTimeout(() => {
                        this.$nextTick(() => {
                            // this.initTreeData();
                            this.draw();
                            this.draw3();
                        });
                    }, 1000);
                    console.log(this.lcountArr, 'this.lcountArr6666666666666');
                } else if (name == 'zx') {
                    var arr = [];
                    var marr = [];
                    for (var k in res.data) {
                        //遍历对象，k即为key，obj[k]为当前k对应的值
                        console.log(res.data[k]);
                        arr.push(res.data[k]);
                        marr.push(k);
                    }
                    this.marr = marr;
                    this.montDataArr = arr.map(item => {
                        return item.count;
                    });
                    this.xsArr = arr.map(item => {
                        return item.amount;
                    });
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.drawzx();
                            this.drawzx2();
                        });
                    }, 2000);
                    console.log(this.montDataArr, 'this.montDataArr');
                }
            });
        },
        getData(name, type, startTime, endTime) {
            photometry({ start: startTime, end: endTime, status: '1,2,3,4', type: type }).then(res => {
                if (name == 'bt') {
                    var lcountArr = [];
                    this.total = res.data[startTime].count;
                    console.log(res.data[startTime].data_good.length, 'res.data[startTime].data_good.length');
                    if (res.data[startTime].data_good.length != 0) {
                        for (var l in res.data[startTime].data_good) {
                            console.log(res.data[startTime].data_good[l].count, 'l.con');
                            var obj = {};
                            obj.name = res.data[startTime].data_good[l].name;
                            obj.count = res.data[startTime].data_good[l].count;
                            lcountArr.push(obj);
                            //遍历对象，k即为key，obj[k]为当前k对应的值
                        }
                        this.lcountArr = [
                            { value: lcountArr[0].count, name: lcountArr[0].name.slice(4) },
                            { value: lcountArr[1].count, name: lcountArr[1].name.slice(4) },
                        ];
                    } else {
                        this.lcountArr = [];
                    }
                    setTimeout(() => {
                        this.$nextTick(() => {
                            // this.initTreeData();
                            this.draw3();
                        });
                    }, 1000);
                    console.log(this.lcountArr, 'this.lcountArr6666666666666');
                } else if (name == 'orderly') {
                    var keyArr = [];
                    var sortArr = [];

                    this.count = res.data[startTime].count;
                    for (var key in res.data[startTime].data_city) {
                        console.log(key, 'cithkey');
                        console.log(getCityTitles([key.split('_')[0], key.split('_')[1]]), '/*/**/*/*/*');
                        var cityObj = {};
                        cityObj.num = res.data[startTime].data_city[key].count;
                        if ([key.split('_')[0]] == '') {
                            cityObj.city = '其他';
                        } else {
                            cityObj.city = getCityTitles([key.split('_')[0], key.split('_')[1]])[1];
                        }

                        keyArr.push(cityObj);
                        sortArr.push(res.data[startTime].data_city[key].count);
                        console.log(res.data[startTime].data_city[key], 'res.data.[key]');
                        // arr.push(res.data[k]);
                        // marr.push(k);
                    }
                    var newsortArr = keyArr.sort((a, b) => b.num - a.num);
                    this.keyArr = newsortArr.filter((item, index) => index < 5);
                    this.keyArr.forEach((item, zindex) => {
                        item.index = zindex + 1;
                    });
                } else if (name == 'zx') {
                    var arr = [];
                    var marr = [];
                    for (var k in res.data) {
                        //遍历对象，k即为key，obj[k]为当前k对应的值
                        console.log(res.data[k]);
                        arr.push(res.data[k]);
                        marr.push(k);
                    }
                    this.marr = marr;
                    this.montDataArr = arr.map(item => {
                        return item.count;
                    });
                    this.xsArr = arr.map(item => {
                        return item.amount;
                    });
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.drawzx2();
                        });
                    }, 2000);
                }
            });
        },
        drawzx() {
            var chartDom = document.getElementById('main1');
            var myChart = echarts.init(chartDom);
            var option;
            var self = this;
            var arr = JSON.parse(JSON.stringify(this.montDataArr));
            console.log(Array(this.montDataArr), 'this.montDataArr11222');
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ['销售订单数'],
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {},
                //     },
                // },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.marr,
                },
                yAxis: {
                    type: 'value',
                },
                series: [
                    {
                        name: '销售订单数',
                        type: 'line',
                        stack: 'Total',
                        data: arr,
                    },
                    // {
                    //     name: '经销商',
                    //     type: 'line',
                    //     stack: 'Total',
                    //     data: [220, 182, 191, 234, 290, 330, 310],
                    // },
                ],
            };

            option && myChart.setOption(option);
        },

        draw3() {
            var chartDom = document.getElementById('main3');
            var myChart = echarts.init(chartDom);
            var option;
            var lcountArr = this.lcountArr;
            console.log(lcountArr, 'lcountArr**************');
            option = {
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    left: '75%',
                    orient: 'vertical', // 设置图例竖向展示
                    x: 'right', // 设置图例位置在右侧
                    y: 'center', // 设置图例垂直居中
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        padAngle: 5,
                        itemStyle: {
                            borderRadius: 10,
                        },
                        label: {
                            show: false,
                            position: 'center',
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 40,
                                fontWeight: 'bold',
                            },
                        },
                        labelLine: {
                            show: false,
                        },
                        data: this.countArr,
                    },
                ],
            };

            option && myChart.setOption(option);
        },
        drawzx2() {
            var chartDom = document.getElementById('main2');
            var myChart = echarts.init(chartDom);
            var option;
            option = {
                title: {
                    text: '',
                },
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ['销售额'],
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {},
                //     },
                // },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.marr,
                },
                yAxis: {
                    type: 'value',
                },
                series: [
                    {
                        name: '销售额',
                        type: 'line',
                        stack: 'Total',
                        data: this.xsArr,
                    },
                ],
            };

            option && myChart.setOption(option);
        },
        draw() {
            var chartDom = document.getElementById('main');
            var myChart = echarts.init(chartDom);
            var option;
            var lcountArr = this.lcountArr;
            console.log(lcountArr, 'lcountArr**************');
            option = {
                tooltip: {
                    trigger: 'item',
                },
                legend: {
                    left: '75%',
                    orient: 'vertical', // 设置图例竖向展示
                    x: 'right', // 设置图例位置在右侧
                    y: 'center', // 设置图例垂直居中
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        padAngle: 5,
                        itemStyle: {
                            borderRadius: 10,
                            normal: {
                                color: function (colors) {
                                    var colorList = ['rgb(182,182,182)', '#5470c6'];
                                    return colorList[colors.dataIndex];
                                },
                            },
                        },
                        label: {
                            show: false,
                            position: 'center',
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 40,
                                fontWeight: 'bold',
                            },
                        },
                        labelLine: {
                            show: false,
                        },
                        // data: this.lcountArr,
                        data: [0],
                    },
                ],
            };

            option && myChart.setOption(option);
        },
        //获取详情
        getDetail() {
            this.showAjaxLoading();
            let reqData = {
                mo: moDef.todaySalePrice,
            };
            reqSalesStat(reqData)
                .then(res => {
                    this.todaySalePrice = +(res?.data?.row || 0) || 0;
                    console.log('今日销售额 request', reqData, 'res', res);
                })
                .finally(() => {
                    this.hideAjaxLoading();
                });
        },
        //查询销售明细、单品销量
        onSearchDetail(arrDate) {
            console.log('onSearchDetail', arrDate);
            this.showAjaxLoading();
            let timeDate = '';
            if (!!arrDate[0] && !!arrDate[1]) {
                timeDate = JSON.stringify([arrDate[0], arrDate[1]]);
            }

            let reqData = {
                mo: moDef.totalSalePrice,
                timeDate,
            };
            reqSalesStat(reqData)
                .then(res => {
                    this.totalSalePrice = +(res?.data?.row || 0) || 0;
                    console.log('累计销售额 request', reqData, 'res', res);
                })
                .finally(() => {
                    this.hideAjaxLoading();
                });

            let dataSalesStat = {
                mo: moDef.saleDetail,
                timeDate,
            };
            reqSalesStat(dataSalesStat)
                .then(res => {
                    let salesDetail = res?.data?.list || [];
                    if (salesDetail.length > 50) {
                        salesDetail = salesDetail.slice(0, 50);
                    }

                    salesDetail.forEach(info => {
                        info.name = info.ctime || '';
                        info.value = info.nums || 0;
                    });
                    this.salesDetail = salesDetail;
                    console.log('销售明细', dataSalesStat, 'res', res);
                })
                .finally(() => {
                    this.hideAjaxLoading();
                });

            this.goodsTableShow = false;
            let dataGooodSale = {
                mo: moDef.goodSaleDetail,
                timeDate,
            };
            reqSalesStat(dataGooodSale)
                .then(res => {
                    this.salesRankList = res?.data?.goodList || [];
                    console.log('销售明细', dataGooodSale, 'res', res);
                })
                .finally(() => {
                    this.goodsTableShow = true;
                });
        },
    },
};
</script>

<style lang="less" scoped>
.data {
    position: relative;
    min-width: 400px;
    max-width: 400px;
    height: 150px;
    border: 2px #333333 solid;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.data-num {
    font-size: 40px;
    font-weight: bold;
}
.data-font {
    position: absolute;
    left: 10px;
    top: 10px;
}
.sales_statistics_panel {
    .card_panel {
        gap: 15px;
        .card {
            flex: 1;
        }
    }

    .money_panel {
        width: 48%;
        min-width: 500px;
    }
    .detail_panel {
        gap: 20px;
        .detail_item {
            width: 48%;
            min-width: 500px;
        }
    }
}
</style>
